export default "__VITE_ASSET__DyQwkrw5__"